export const environment = {
    production: true,
    envName: 'dev',
    local: false,
    live_url: 'https://attendo-dk-dev.appbolaget.se',
    version: '2.0.0',
    bugsnag: {
        apiKey: '81f1e39d185d22337ee6a48e6f2b19ad',
    },
    api: {
        url: 'https://api-attendo-dev.appbolaget.se',
        devUrl: null,
        unit: '47ff9d75-a642-48f8-87b5-4c251e2bff16',
        source: 'attendo.appbolaget.se',
        app: 'dk.appbolaget.attendo',
    },
    maps: {
        apiKey: 'AIzaSyAdFwghqD3Kevfcrx69_bHYVsDCX4XokcA',
    },
    app: {
        id: 'dk.appbolaget.attendo',
    },
    sentry: {
        dsn: 'https://be89cb0a02d84afc97e4e07df2df5294@sentry.appbolaget.dev/13',
    },
};
